export default __webpack_public_path__ + "static/media/download01.5d816699.svg";